import * as Sentry from '@sentry/react';
import { getCurrentCopy } from './i18n/current';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Button } from './components/ui/button';
import { checkAndInitGA4 } from './services/analyticsService';
import { captureAttribution } from './lib/attribution';
import './styles/global.css';
import { registrarServiceWorker } from './pwa/swRegistration';

// Inicializar Sentry antes de tudo (só em produção)
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD,
    tracesSampleRate: 0,
    ignoreErrors: [
      'AbortError',
      'ResizeObserver loop',
      'Network request failed',
    ],
  });
}

// Capturar atribuição (gclid/UTMs) no primeiro acesso, antes de qualquer
// navegação interna que limpe a query string. First-touch, janela de 90 dias.
captureAttribution();

// Inicializar GA4 se o usuário já aceitou cookies anteriormente
checkAndInitGA4();

// Fallback UI para o error boundary (mesma UI do anterior)
function FallbackComponent({ error }: { error: unknown }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      padding: '20px',
      textAlign: 'center',
      backgroundColor: '#1a1a2e',
      color: '#fff',
      fontFamily: 'system-ui, sans-serif'
    }}>
      <h1 style={{ color: 'var(--color-danger)', marginBottom: '16px' }}>{getCurrentCopy().common.appShell.bootErrorTitle}</h1>
      <p style={{ marginBottom: '12px', color: '#ccc' }}>
        {getCurrentCopy().common.appShell.bootErrorDescription}
      </p>
      {!!(import.meta.env.DEV && error) && (
        <pre style={{
          backgroundColor: '#2d2d44',
          padding: '16px',
          borderRadius: '8px',
          maxWidth: '600px',
          overflow: 'auto',
          fontSize: '12px',
          textAlign: 'left',
          color: '#ff6b6b'
        }}>
          {String(error)}
        </pre>
      )}
      <Button
        onClick={() => window.location.reload()}
        style={{
          marginTop: '20px',
          padding: '10px 20px',
          backgroundColor: 'var(--color-info)',
          color: '#fff',
          borderRadius: '6px',
        }}
      >
        {getCurrentCopy().common.appShell.bootErrorAction}
      </Button>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog={false}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);


// Service worker no arranque, independente de login: e infraestrutura, nao UI.
registrarServiceWorker();
